<!-- 盒子 -->
 <template>
    <div class="box">
        <div class="box-header" v-if="showheader">
            <div class="box-header__left">
                <span class="title">{{title}}</span>
                <el-tooltip effect="dark" :content="tipsContent"
                    placement="top">
                    <img class="icon-pic" v-if="tipsContent"  @mouseenter="mouseenter(classLog)" src="@/assets/images/icon-question.png" />
                </el-tooltip>
                <span class="sub-title" v-if="showHeaderUnit">单位：万元</span>
            </div>
            <div class="box-header__right">
                <slot name="header-right"></slot>
            </div>
        </div>

        <slot>
            <span>内容区域</span>
        </slot>
    </div>
 </template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: () => {
                return '标题';
            }
        },
        tipsContent: {
            type: String,
            default: () => {
                return '';
            }
        },
        classLog: {
            type: String,
            default: () => {
                return '';
            }
        },
        showheader: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        showHeaderUnit: {
            type: Boolean,
            default: () => {
                return true;
            }
        }
    },
    setup(props, setupContext) {
        const mouseenter = (val) => {
            setupContext.emit('mouseenter', val);
        };
        return {
            mouseenter
        };
    }
};
</script>
<style lang="less" scoped>
.box{
    box-sizing: border-box;
    padding: 16px;
    // display: flex;
    // flex-direction: column;
    background: #ffffff;
    border-radius: 4px;
    width: 100%;
    backdrop-filter: blur(25px);
    &-header{
        margin: 0 0 10px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__left{

        }
        &__right{

        }

    .title{
        color: #333333;
        font-size: 14px;
        font-weight: 500;
    }
    .sub-title{
        margin-left: 10px;
        color: #86909C;
        font-size: 12px;
    }
    .icon-pic {
        width: 12px;
        height: 12px;
        margin-left: 4px;
    }
    }
}
</style>
